"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _IconFormatting = require("../IconFormatting");

var _Theme = require("../../Theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var BrandingIcon = function BrandingIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    viewBox: "0 0 96 96"
  }, props), _react.default.createElement(_IconFormatting.PathPrimaryStroke, {
    as: "rect",
    x: "2.64",
    y: "7.36",
    width: "90.67",
    height: "59",
    rx: "2.88",
    ry: "2.88",
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    theme: props.theme
  }), _react.default.createElement(_IconFormatting.PathContrast, {
    d: "M31.06 25.81l8.31 9.9 12.37-20.15 22.09 38-60.04.06 17.27-27.81z",
    theme: props.theme
  }), _react.default.createElement(_IconFormatting.PathPrimaryStroke, {
    as: "rect",
    x: "28.4",
    y: "84.69",
    width: "39.68",
    height: "5.83",
    rx: "2.57",
    ry: "2.57",
    fill: "none",
    strokeWidth: "1.5",
    theme: props.theme
  }), _react.default.createElement(_IconFormatting.PathPrimaryStroke, {
    d: "M28.72 85.94l7.83-19.7m23.34 0l7.75 19.54",
    strokeMiterlimit: "10",
    fill: "none",
    strokeWidth: "1.5",
    theme: props.theme
  }), _react.default.createElement(_IconFormatting.PathPrimaryStroke, {
    d: "M37.73 29.31l8.3 9.9 12.38-20.15 22.09 38-60.04.06 17.27-27.81z",
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    theme: props.theme
  }));
};

BrandingIcon.defaultProps = {
  theme: _Theme.defaultTheme
};
var _default = BrandingIcon;
exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/Icon/icons/BrandingIcon.js